function t(e, ...n) {
  e != null && e.addEventListener && e.addEventListener(
    ...n
  );
}
function i(e, ...n) {
  e != null && e.removeEventListener && e.removeEventListener(
    ...n
  );
}
export {
  t as a,
  i as o
};
//# sourceMappingURL=events-DamQnLE5.js.map
